export const AUTH_REQUEST = 'auth-request';
export const AUTH_ERROR = 'auth-error';
export const AUTH_SUCCESS = 'auth-success';
export const AUTH_LOGOUT = 'auth-logout';
export const AUTH_LOGGING_OUT = 'auth-logging-out';
export const INTEGRATION_AUTH_REQUEST = 'integration-auth-request';
